module.exports = __webpack_public_path__ + "img/瓦楞子.20b4435f.jpg";